import { useRouter } from 'next/router'
import useSWR, { mutate } from 'swr'
import { useRunOnceReady } from 'utils/hooks'

const beemUserIdQueryParamName = 'user_id'
const sessionStorageBeemUserIdKey = '@goodtrust/beemUserId'
export const swrBeemUserIdKey = '@goodtrust/beemUserId'

/**
 * Saves the Beem user ID from the URL (`?user_id=...`) into sessionStorage so
 * it can later be attached to the registration request. Should be called once
 * globally (in `_app.tsx`) so it works for any page the user lands on.
 *
 * See https://cleevio.atlassian.net/browse/GT-? — Beem links look like
 * `https://mygoodtrust.com/?promo=Be09x3u2n&user_id=111`
 */
export function useSaveBeemUserIdFromURL() {
  const router = useRouter()
  useRunOnceReady(router.isReady, () => {
    tryStoreBeemUserId(router.query[beemUserIdQueryParamName])
  })
}

export function tryStoreBeemUserId(value?: string | string[]) {
  try {
    const val = Array.isArray(value) ? value[0] : value
    if (!val) return
    sessionStorage.setItem(sessionStorageBeemUserIdKey, val)
    mutate(swrBeemUserIdKey)
  } catch {}
}

export function getStoredBeemUserId(): string | null {
  try {
    return sessionStorage.getItem(sessionStorageBeemUserIdKey)
  } catch {
    return null
  }
}

export function clearStoredBeemUserId() {
  try {
    sessionStorage.removeItem(sessionStorageBeemUserIdKey)
    mutate(swrBeemUserIdKey)
  } catch {}
}

export function useStoredBeemUserIdSwr() {
  return useSWR(swrBeemUserIdKey, () => getStoredBeemUserId())
}
